import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { ShortUrlEntry } from '../context/types';

import { getShortUrl } from './getShortUrl';

export async function getShortUrls(
	entries: readonly ShortUrlEntry[],
	utilityContext: UtilityContext,
): Promise<Readonly<Record<string, string>>> {
	const shortUrls = await Promise.all(
		entries.map(async (entry) => getShortUrl(entry.normalizedLongUrl, utilityContext)),
	);
	return entries.reduce<Record<string, string>>((map, entry, index) => {
		// eslint-disable-next-line no-param-reassign
		map[entry.longUrl] = shortUrls[index];
		return map;
	}, {});
}
